import { AppBar, AppBarProps } from '@mui/material';

const AppBarWrapper: React.FC<AppBarProps> = ({ children, ...props }) => <AppBar {...props}>{children}</AppBar>;

export default AppBarWrapper;
